/* eslint-disable no-param-reassign */
export const loadImage = (src: string, srcset?: string, sizes?: string) => {
  const image = new Image();

  return new Promise<HTMLImageElement>((resolve, reject) => {
    image.onload = () => {
      resolve(image);
      unbindEvents(image);
    };

    image.onerror = (error) => {
      reject(error);
      unbindEvents(image);
    };

    if (sizes) {
      image.sizes = sizes;
    }

    if (srcset) {
      image.srcset = srcset;
    }

    image.src = src;

    if (image.complete) {
      resolve(image);
      unbindEvents(image);
    }
  });
};

const unbindEvents = (image: HTMLImageElement) => {
  image.onload = null;
  image.onerror = null;
};
